import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inputFields", "totalMonths", "yearsField", "additionalMonthsField"]

  connect() {
    this.inputFieldsTarget.style.display = "block";
    this.totalMonthsTarget.style.display = "none";
    this.updateYearAndMonthFields();
  }

  calculateTotalMonths() {
    this.updateTotalMonths();
  }

  updateTotalMonths() {
    const years = parseInt(this.yearsFieldTarget.value) || 0;
    const additionalMonths = parseInt(this.additionalMonthsFieldTarget.value) || 0;
    const totalMonths = (years * 12) + additionalMonths;
    this.totalMonthsTarget.value = totalMonths;
  }

  updateYearAndMonthFields() {
    const totalMonths = parseInt(this.totalMonthsTarget.value);
    if (!isNaN(totalMonths)) {
      const years = Math.floor(totalMonths / 12);
      const additionalMonths = totalMonths % 12;
      this.yearsFieldTarget.value = years;
      this.additionalMonthsFieldTarget.value = additionalMonths;
    }
  }
}
